<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  sub: { type: String, default: '' },
  icon: { type: String, default: 'i-lucide-activity' },
  tone: { type: String, default: 'slate' },
});

const TONES = {
  blue: { icon: 'text-blue-600', bg: 'bg-blue-50 dark:bg-blue-900/20' },
  emerald: {
    icon: 'text-emerald-600',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
  },
  amber: { icon: 'text-amber-600', bg: 'bg-amber-50 dark:bg-amber-900/20' },
  red: { icon: 'text-red-600', bg: 'bg-red-50 dark:bg-red-900/20' },
  violet: { icon: 'text-violet-600', bg: 'bg-violet-50 dark:bg-violet-900/20' },
  slate: { icon: 'text-n-slate-11', bg: 'bg-n-alpha-2' },
};

const tone = computed(() => TONES[props.tone] || TONES.slate);
</script>

<template>
  <div
    class="flex flex-col gap-3 p-4 bg-white dark:bg-n-alpha-2 rounded-xl border border-n-weak shadow-sm"
  >
    <div class="flex items-center justify-between">
      <p class="text-xs font-medium text-n-slate-10 uppercase tracking-wide">
        {{ label }}
      </p>
      <div class="p-1.5 rounded-lg" :class="tone.bg">
        <span class="w-4 h-4" :class="[icon, tone.icon]" />
      </div>
    </div>
    <p class="text-2xl font-bold text-n-slate-12">{{ value }}</p>
    <p v-if="sub" class="text-xs text-n-slate-9">{{ sub }}</p>
  </div>
</template>
